import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FilterRadio } from "./list.filter";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgIf, NgFor } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";

@Component({
  selector: "app-filter-radio",
  templateUrl: "./filter.radio.component.html",
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    MatRadioModule,
    NgFor,
  ],
})
export class FilterRadioComponent implements OnInit {
  _common = _common;

  @Input()
  filter = new FilterRadio();
  @Input()
  values: any[];
  @Input()
  names: string[];

  @Input()
  visible = true;
  @Input()
  set objectValues(c: any[]) {
    this.values = c.map((c) => c.id?.toString());
    this.names = c.map((c) => c.name);
  }

  @Input()
  set common(c: any) {
    this.names = this.values.map((v) => c[v] || v);
  }

  @Output()
  change = new EventEmitter<void>();

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["values"]) {
      if (!this.names) this.names = this.values;
    }
  }

  refresh() {
    this.change.next(void 0);
  }
}
